export default __webpack_public_path__ + "static/media/login-as-hero.3d0083df.png";